import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonRatingDTOBase } from "./PersonRatingDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { ProgramTypeRef } from "./ProgramTypeRef";
import type { ProgramTypeStaff } from "./ProgramTypeStaff";
import type { RatingRef } from "./RatingRef";
import type { RatingStaff } from "./RatingStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonRatingStaff implements PersonRatingDTOBase, TrackedBase {
  constructor(public readonly assignId: number, public readonly personId: PersonStaff | null, public readonly ratingId: RatingStaff | null, public readonly programId: ProgramTypeStaff | null, public readonly testSignoutId: number | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly ratingIdTargetIds: RatingRef, public readonly programIdTargetIds: ProgramTypeRef | null, public readonly ratingName: string | null, public readonly ratingCategory: string | null, public readonly programName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.ratingIdLoaded = this.ratingId != null;
    this.ratingIdCached = this.ratingId;
    this.programIdLoaded = this.programId != null;
    this.programIdCached = this.programId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private ratingIdLoaded: boolean;
  private ratingIdCached: RatingStaff | null;
  private programIdLoaded: boolean;
  private programIdCached: ProgramTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.ratingService().getPersonRatingStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async ratingIdLazy(): Promise<RatingStaff> {
    if (!this.ratingIdLoaded) {
      this.ratingIdCached = await this.cbiServiceContext!.ratingService().getRatingStaff(this.ratingIdTargetIds.ratingId);
      this.ratingIdLoaded = true;
    }
    return this.ratingIdCached!;
  }
  async programIdLazy(): Promise<ProgramTypeStaff | null> {
    if (!this.programIdLoaded) {
      this.programIdCached = await (this.programIdTargetIds != null ? this.cbiServiceContext!.programTypeService().getProgramTypeStaff(this.programIdTargetIds.programId) : Promise.resolve(null));
      this.programIdLoaded = true;
    }
    return this.programIdCached;
  }
}
